import React, { createContext, useContext, useState, useEffect } from 'react';

/**
 * User Context - Centralized user state management
 * 
 * Currently: Manages persona-selected user
 * Future: Will integrate with authentication system
 * 
 * This context provides the current user to all child components,
 * preparing for when authentication is implemented.
 */

const UserContext = createContext({
  currentUser: null,
  setCurrentUser: () => {},
  isAuthenticated: false,
});

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};

export const UserProvider = ({ children, initialUser = null }) => {
  const [currentUser, setCurrentUser] = useState(initialUser);
  
  // Future: This will check auth token/session
  const isAuthenticated = !!currentUser;
  
  useEffect(() => {
    // Update when initialUser changes (persona selection)
    if (initialUser) {
      setCurrentUser(initialUser);
    }
  }, [initialUser]);
  
  const value = {
    currentUser,
    setCurrentUser,
    isAuthenticated,
  };
  
  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
